import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

import { MaintenancePrintsParamsComponent } from "./maintenance-prints-params.component";

const routesPrintsParams: Routes = [
  {
    path: "parametros-impresion",
    component: MaintenancePrintsParamsComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesPrintsParams)],
  exports: [RouterModule],
})
export class PrintsParamsRoutingModule {}
